import React from 'react';

type Props = {
  delay: number
}

export default function Deadline ({ delay, }: Props): React.ReactElement {
  return (
    <div className="box">
      <p className="title is-level-3">Délais</p>
      { delay === -1 ?
        <p className="text is-level-1 is-marginless">Nous n&apos;avons pas réussi à déterminer le nombre de jours restant par rapport au dernier état du dossier.</p>
        : 
        <p className="text is-level-1 is-marginless">Il reste <span className="has-text-weight-semibold">{ delay } jour{ delay === 1 ? '' : 's' }</span> avant restitution de votre équipement (à titre indicatif).</p>
      }
    </div>
  );
}